import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { statusBadgeText } from "./fulfillment-group-csv-helpers";

export const StatusCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Status",
    cell: (row) => {
      return statusBadgeText[row.status || FulfillmentGroupStatus.Open];
    },
  };
